var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-box"},[_c('div',{staticClass:"nav-content flex flex-center"},[(_vm.back)?_c('div',{staticClass:"back flex flex-center",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../assets/back.png"),"alt":""}}),_c('span',[_vm._v("返回")])]):_vm._e(),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }